import React from 'react';
import { Typography } from '@mui/material';
import { getProficiencyValue } from '../ProficiencyUtils'; // Assuming this path after moving getProficiencyValue

const TextProficiency = ({ proficiency, classes, colors }) => {
  // Unlike Stars/Bars, TextProficiency should render even if proficiency maps to 0,
  // as it's just displaying the original text.
  // However, if proficiency itself is empty/null, we render nothing.
  if (!proficiency) return null;
  
  const secondaryColor = colors?.textSecondary || '#aaa';

  return (
    <Typography
      component="span"
      className={`${classes?.proficiencyVisualization || ''} ${classes?.smallText || ''}`}
      sx={{ marginLeft: '8px', color: secondaryColor }}
    >
      ({proficiency})
    </Typography>
  );
};

export default TextProficiency; 